import React from 'react';
import './EventDetails.less';
import { inject, observer } from 'mobx-react';
import { Row, Col, Card, AppLocaleProvider } from 'sd-ui-components';
import AppLayout from '../AppLayout/AppLayout';
import BackBreadcrumb from '../Common/BackBreadcrumb';
import PageLoadLogger from '../../utils/PageLoadLogger';
import EventSummary from './EventSummary';
import EventTabs from './EventTabs';
import Notifications from '../../components/Notifications/Notifications';

const { FormattedMessage } = AppLocaleProvider;

@inject('ConfigStore')
@inject('EventsStore')
@observer
class SingleEvent extends React.Component {
  state = {};

  pageLoadLogger = new PageLoadLogger('Single event');

  async componentDidMount() {
    this.updateEvent();

    this.pageLoadLogger.capture();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.eventNumber !== this.props.eventNumber) {
      this.updateEvent();
    }
  }

  componentWillUnmount() {
    this.props.EventsStore.cancelLoadEventDetails();
  }

  updateEvent() {
    const eventNumber = this.props.eventNumber;

    this.props.EventsStore.setSelectedEventNumber(eventNumber);
    this.props.EventsStore.loadEventDetails([this.props.eventNumber]);
  }

  render() {
    const { EventsStore } = this.props;

    const event = EventsStore.selectedEventDetails;

    return (
      <AppLayout>
        <BackBreadcrumb
          to="/safety"
          data-automation-id="sd-ui-driver-navigation-breadcrumb-safety"
        >
          <FormattedMessage
            id="App.Navigation.BackToDriverSafetyOverview"
            defaultMessage="Back to Driver Safety overview"
          />
        </BackBreadcrumb>

        <Row>
          <Col span={24}>
            <Notifications />
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Card
              key={event.eventNumber}
              className="event-detail-card"
              loading={EventsStore.loading.eventDetails}
            >
              <div>
                <EventSummary event={event} />
                <EventTabs event={event} />
              </div>
            </Card>
          </Col>
        </Row>
      </AppLayout>
    );
  }
}

export default SingleEvent;



// WEBPACK FOOTER //
// ./src/containers/EventDetails/SingleEvent.jsx